let navigate;

export const setNavigate = (nav) => {
  navigate = nav;
};

export const redirectPage = (page = "/entrar") => {
  navigate(page);
};